import { useTranslation } from 'react-i18next';
import { StyledMetaData } from './styles';
import BasicModal from '__components/Modals/presets/BasicModal';

export function HistoryDetailsModal<T extends Record<string, any>>({
  data,
  onHide,
}: {
  data: T;
  onHide(): void;
}) {
  const { t } = useTranslation();

  return (
    <BasicModal
      show
      onHide={onHide}
      onConfirm={onHide}
      heading={t('Timeline Details')}
      leftBtn={null}
      buttonText={t('Close')}
      actionBtnColor="blue"
      size="medium"
    >
      <StyledMetaData>{JSON.stringify(data || {}, null, 2)}</StyledMetaData>
    </BasicModal>
  );
}
